import BossModel from "@/models/BossModel";
import Dossier from "@/models/Dossier/Dossier";

export default class ActivePhoneCall extends BossModel {

    /**
     *
     * @type {string}
     */
    static entity = 'activePhonecalls';

    static primaryKey = 'reference';

    static fields() {
        return {
            reference: this.attr(null),
            is_sticky: this.boolean(false),
            event: this.attr(null),
            system: this.attr(null),
            transferring: this.attr(null),
            dossier_id: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            phone_call_id: this.number(null).nullable(),
            start_time: this.attr(null),
            answered_time: this.attr(null),
            end_time: this.attr(null),
            from: this.attr({}),
            to: this.attr({}),
            message: this.attr(null),
            flow_ids: this.attr([]),
            dossier: this.belongsTo(Dossier, 'dossier_id'),
        }
    }
}
